<template>
  <div class="center-warp">
    <div class="inner warp-page">
      <div class="top-nav">
        <div :class="navIndex == 1 ? 'on' : ''" @click="navChange(1)">未建复诊卡病例({{ navCountNum.unCreate }})</div>
        <div :class="navIndex == 2 ? 'on' : ''" @click="navChange(2)">无人受理病例({{ navCountNum.unAccept }})</div>
        <div :class="navIndex == 3 ? 'on' : ''" @click="navChange(3)">新咨询导师未回复病例({{ navCountNum.unReply }})</div>
      </div>

      <div v-if="!showCaseList" v-loading="loading">
        <div class="bottom-data">
          <div class="bottom-data-item" v-for="item in list" style="height: 118px">
            <img :src="item.head_pic" alt="">
            <div>
              <div class="bottom-data-item-info1">{{ item.real_name }}医生</div>
              <div class="bottom-data-item-info2">{{ item.province }}·{{ item.city }}/{{ item.organization }}</div>
            </div>
            <div class="bottom-data-case d-flex-between" @click="goPatient(item)">
              <div>{{ item.patient_count }}个病例</div>
              <div class="iconfont icon-youjiantou"></div>
            </div>
          </div>
          <Empty style="margin-top: calc(50vh - 250px)" v-if="!list.length" :info="'暂无未建复诊卡病例'" :img-width="'200px'" />
        </div>
        <Pagination :total="total" :page.sync="queryParams.page" :last_page="last_page" @pagination="getList" :key="queryParams.page" />
      </div>

      <!-- 显示医生病例 -->
      <div v-else v-loading="loading">
        <div class="case-list-head d-flex" @click="showCaseList = false" >
            <div class="iconfont icon-fanhui"></div>
            <div>{{ patientItem.real_name }}医生的病例（{{ patientItem.patient_count }}）</div>
        </div>
        <div class="filter-sort" style="width: 100%;margin-top: 10px">
          <div v-for="(item,index) in orderList" :class="index == orderIndex ? 'on' : ''" class="filter-sort-item"
               @click="orderChange(index)">{{ item.name }}·
            <span @click.stop="orderSortChange(index)" class="hover-bg">{{ item.param_name[orderSortIndex[index]] }}<i class="iconfont icon-qiehuan"></i></span>
          </div>
        </div>
        <div class="case-list-warp">
          <div class="case-list-item" v-for="item in patientList">
            <img :src="item.head_pic" alt="">
            <div class="case-list-item-name limit-1">{{item.name}}</div>
            <div class="case-list-item-age limit-1">{{item.age_text}}</div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  curMonthNoFzCardUsers,
  getDoctorListData, getPatientListData, unacceptedUsers, unReplyUsers
} from "@/http/customer_data";
import Pagination from "@/components/Pagination";
import {caseSortList} from "@/assets/js/caseSortList";

export default {
  name: "index",
  components: { Pagination },
  data() {
    return {
      navIndex: 1,
      navCountNum: {
        unCreate:0,
        unAccept:0,
        unReply:0
      },
      showCaseList:false,
      list:[],
      total: 0,
      last_page: 0,
      loading: false,
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      patientItem:{},
      patientList:[],
      orderIndex:0,
      orderSortIndex:[0,0,0,0,0,0],
      orderList: caseSortList,
    };
  },
  mounted() {
    this.getList()
    this.initCountNum()
  },
  methods: {
    initCountNum(){
      curMonthNoFzCardUsers({}).then(res=>this.navCountNum.unCreate = res.data.patient_count)
      unacceptedUsers({}).then(res=>this.navCountNum.unAccept = res.data.patient_count)
      unReplyUsers({}).then(res=>this.navCountNum.unReply = res.data.patient_count)
    },
    navChange(i) {
      this.navIndex = i;
      this.showCaseList = false
      this.getList()
    },
    getList(){
      this.loading = true;
      let url = ''
      if(this.navIndex == 1) url = '/api/case/curMonthNoFzCardUsers'
      else if(this.navIndex == 2) url = '/api/case/unacceptedUsers'
      else url = '/api/case/unReplyUsers'
      getDoctorListData(url,this.queryParams).then(res=>{
        this.list = res.data.data.data;
        this.total = res.data.data.total;
        this.last_page = res.data.data.last_page;
        this.loading = false;
      })
    },
    goPatient(item){
      if(item) this.patientItem = item
      this.loading = true;
      let url = ''
      if(this.navIndex == 1) url = '/api/case/curMonthNoFzCardPatients'
      else if(this.navIndex == 2) url = '/api/case/unacceptedPatients'
      else url = '/api/case/unReplyPatients'
      let orderBy = []
      orderBy.push(this.orderList[this.orderIndex].param)
      orderBy.push(this.orderList[this.orderIndex].param_order[this.orderSortIndex[this.orderIndex]])
      getPatientListData(url,{doctor_id:this.patientItem.id,pageSize:999,orderBy:orderBy}).then(res=>{
        this.patientList = res.data.data
        this.showCaseList = true
        this.loading = false;
      })
    },
    orderChange(i) {
      this.orderIndex = i
      this.goPatient()
    },
    orderSortChange(i) {
      this.$set(this.orderSortIndex,i,Math.abs(this.orderSortIndex[i] - 1))
      if(i == this.orderIndex) this.goPatient()
    },
  },
};
</script>

<style scoped>
@import "../../assets/css/sales_data.css";
</style>
